import classnames from 'classnames';
import { useId } from 'react';
import Flatpickr, { type DateTimePickerProps } from 'react-flatpickr';

import { CalendarIcon } from '../../../icons/CalendarIcon';
import '../../legacy/datePicker.scss';

export type DatePickerProps = DateTimePickerProps & {
  labelText?: string;
  disabled?: boolean;
};

const DatePicker = ({ labelText, id, disabled, ...flatPickerProps }: DatePickerProps) => {
  const defaultOptions: DateTimePickerProps['options'] = {
    enableTime: false,
    minDate: 'today',
    altInput: true,
    altFormat: 'l, j F Y',
    dateFormat: 'Y-m-d',
    disableMobile: true,
    monthSelectorType: 'static',
    inline: false,
    locale: {
      firstDayOfWeek: 1,
    },
  };

  const defaultId = useId();

  return (
    <div className="flex flex-col">
      {labelText && (
        <div className="pb-2">
          <label htmlFor={id || defaultId} className="font-medium">
            {labelText}
          </label>
        </div>
      )}
      <div className="relative">
        <Flatpickr
          {...flatPickerProps}
          id={id || defaultId}
          disabled={disabled}
          options={{ ...defaultOptions, ...flatPickerProps.options }}
          className={classnames(
            'w-full rounded border border-grey-3 px-2 py-2 pr-10 focus:outline-none focus:ring focus:ring-blue-3',
            disabled ? 'bg-slate-2 text-grey-4' : 'bg-white'
          )}
          data-enable-time
        />
        <div className="pointer-events-none absolute right-[10px] top-[10px] flex">
          <CalendarIcon width={24} height={24} className={disabled ? 'fill-grey-4' : 'fill-blue-5'} />
        </div>
      </div>
    </div>
  );
};

export default DatePicker;
